import { useContext, useEffect } from "react";
import { useInRouterContext, useNavigate, useLocation } from "react-router-dom";
import { initApi, onAuth } from "./api/api";
import { AppContext } from "./appContext";
import { GoogleAuthProvider } from "@firebase/auth";

export const Auth = () => {
    initApi();
    const navigate = useNavigate();
    const navLocation = useLocation();
    const appContext = useContext(AppContext);
    useEffect(()=>{
        const authUnsubscribe = onAuth((user)=>{
            if (user){
                /*user.getIdToken().then(tok=>{
                    const gp = GoogleAuthProvider.credential(tok);
                    console.log('gp', gp);
                })*/
                console.log('success login', user);
                appContext.setUser(user);
                console.log('page -', navLocation);
                if (['', '/'].includes(navLocation.pathname)){
                    navigate('/dashboard');
                }
            } else {
                appContext.setUser(null);
                navigate('/login');
            }
        });
        return authUnsubscribe;
    }, []);

    return '';
}
